import * as React from 'react';

import classnames from 'classnames';

import styles from './sliding-drawer.module.css';

type Props = {
    onClose: () => any;
    onOpen: () => void;
    isClosing: boolean;
    isActive: boolean;
    isWide?: boolean;
    children?: React.ReactNode;
    isSidebarCollapsed?: boolean;
};

export class SlidingDrawer extends React.PureComponent<
    Props,
    {
        isAnimatingOut: boolean;
    }
> {
    myMenu: HTMLElement | null | undefined;
    appMenu: HTMLElement | null | undefined;

    constructor() {
        // @ts-expect-error
        super();
        this.state = {
            isAnimatingOut: false,
        };
    }

    componentDidMount() {
        if (this.appMenu) {
            this.appMenu.addEventListener('transitionend', this.onTransitionEnd, false);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        if (nextProps.isClosing && !this.props.isClosing) {
            this.handleClose();
        }
    }

    render() {
        const styleNames = classnames(styles.menu, {
            [styles['menu--visible']]: this.props.isActive && !this.state.isAnimatingOut,
            [styles['menu--animatable']]: this.props.isActive,
            [styles['menu--widebar']]: !this.props.isSidebarCollapsed,
            [styles['menu--with-trial-status-bar']]: NutClientConfig.shouldShowTrialStatusBar,
        });

        const menuStyleName = classnames({
            [styles['app-menu']]: !NutClientConfig.isDemoSilo,
            [styles['app-menu--wide']]: this.props.isWide,
            [styles['app-menu--with-trial-status-bar']]: NutClientConfig.shouldShowTrialStatusBar,
        });

        const agentMount = document.getElementById('team-ai-sidebar');
        const isAgentOpen = agentMount ? agentMount.getAttribute('data-is-open') === 'true' : false;

        return (
            <div
                ref={(node) => {
                    this.myMenu = node;
                }}
                onClick={this.handleClose}
                data-is-ai-agent-open={isAgentOpen}
                className={styleNames}
            >
                <div
                    ref={(node) => {
                        this.appMenu = node;
                    }}
                    onClick={this.preventClose}
                    className={menuStyleName}
                >
                    {this.props.children}
                </div>
            </div>
        );
    }

    preventClose = (e: React.SyntheticEvent) => {
        e.stopPropagation();
    };

    onTransitionEnd = (e: Event) => {
        // We only want to react to transitions of the appMenu itself
        if (e.target !== this.appMenu) return;

        // If we haven't yet removed the animatable style, that means we just
        // finished opening.
        if (document.querySelector(`.${styles['menu--animatable']}`)) {
            this.props.onOpen();
        }

        if (this.myMenu) {
            this.myMenu.classList.remove(styles['menu--animatable']);
        }
    };

    handleClose = () => {
        this.setState({isAnimatingOut: true}, () => {
            setTimeout(() => {
                this.props.onClose();
                this.setState({isAnimatingOut: false});
            }, 220);
        });
    };
}
